const url = "https://fastapi-linktree.herokuapp.com"

export default {url};
